import { observable } from "mobx"
import { classCollection, FbUtils } from "../../common/FirebaseConfig"
import { log } from "../../common/Logging"
import { ClassGrade, Clazz } from "../../shared/models/Clazz"

export class ClassStoreSA {
    private static innerInstance: ClassStoreSA

    @observable
    clazz?: Clazz

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    is5thGrade = () => {
        if (this.clazz != null) {
            return this.clazz.classGrade === ClassGrade.FIFTH
        }
        throw new Error("No class loaded, can't determine grade!")
    }

    loadClass = async (id: string) => {
        const classResult = await classCollection().doc(id).get()
        this.clazz = FbUtils.queryDocToDoc(classResult) as Clazz
    }

    findClassByCode = async (classCode: string) => {
        if (classCode == null) {
            throw new Error("Invalid class code sent to find class by code.")
        }

        const codeClean = classCode.trim().toLowerCase()
        log.debug(`Checking class code against ${codeClean}`)
        const classRef = classCollection()
        const classes = await classRef.where("code", "==", codeClean).get()

        return FbUtils.queryToSingleDoc(classes) as Clazz
    }
}
